import type { SymptomCheckerTriageLevelValues } from 'constants/_types/SymptomCheckerTriageLevels';
import { triageLevelNamesTranslationArrays } from 'helpers/_translations/triageLevelNamesTranslationArrays';

export const getCurrentRowTriageLevelTranslationArray = (currentTriageLevel: SymptomCheckerTriageLevelValues) =>
  triageLevelNamesTranslationArrays.find(triageLevelName => triageLevelName[0].includes(currentTriageLevel)) ?? [''];
